// extracted by mini-css-extract-plugin
export default {"container":"styles_container__W7xCh","content":"styles_content__OZb-d"};